// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"f4836f4e","894":"d343a11a"}[chunkId] + ".chunk.js";
};